import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '@iconify-icon/react';
import Select from './Select';
import { cn } from '@monorepo/utils';
const FilterSelect = ({ selectedValue, handleFilterChange, classNames, ...props }) => (_jsx(Select, { withCheckIcon: false, value: selectedValue, classNames: {
        input: cn('w-24 text-sm', { 'text-center  p-0': selectedValue }, classNames?.input),
        option: cn('text-sm', classNames?.option),
        label: cn('text-sm', classNames?.label),
        section: cn('text-gray-800', classNames?.section),
    }, leftSection: !selectedValue ? _jsx(Icon, { icon: "mynaui:filter-solid", className: "cursor-pointer text-xl" }) : null, leftSectionPointerEvents: "none", allowDeselect: false, leftSectionWidth: "45%", rightSectionWidth: 0, rightSection: false, placeholder: "Filter", onChange: (value) => handleFilterChange(value), ...props }));
export default FilterSelect;
